<template>
  <div>
    <div class="container-fluid white-bg no-shadow">
      <div class="container align-middle">
        <div class="row">
          <div class="col-12">
            <div class="land-t-delimeter" style="margin-bottom: 60px;"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p>Перед школой многие родители устраивают своих детей во всевозможные кружки, курсы, центры раннего развития, языковые центры. Современные технологии позволяют &laquo;ходить&raquo; на такие занятия онлайн, особенно востребована такая форма обучения в сфере изучения иностранных языков. Дистанционное обучение дошкольников французскому языку очень популярно и позволяет в удобное для ученика время получать знания в интерактивном формате.</p>

            <h3 class="redh3">Что такое HomeTeacher</h3>

            <p>HomeTeacher &ndash; это образовательная платформа, на которой дошкольники, школьники и взрослые могут осваивать самые востребованные иностранные языки.</p>

            <h3 class="greenh2">Как заниматься на HomeTeacher:</h3>

            <ol>
              <li><span>С помощью фильтров &laquo;язык&raquo; и &laquo;возраст&raquo; выбираете интересующий вас&nbsp; курс.</span></li>
              <li><span>Производите оплату. Важно отметить, что у всех курсов есть бесплатные пробные уроки, пройдя которые, вам станет ясно, подходит вам курс или нет.</span></li>
              <li><span>После оплаты вам доступны сами уроки-эпизоды, онлайн-консультации с педагогом, который следит за прогрессом малыша, может ответить на возникшие вопросы. Также вы получаете дополнительные материалы к занятиям и онлайн-тренажеры с интересными тестами для наилучшего запоминания изученной лексики.</span></li>
            </ol>

            <p>Онлайн-обучение дошкольников французскому языку доступно в течение года после оплаты. Французский является одним из самых распространенных языков в мире, поэтому он так популярен для изучения среди детей 4-6 и 7-8 лет.</p>

            <h3 class="redh3">Преимущества онлайн-курсов французского языка для дошкольников с Полиглотиками:</h3>

            <ul>
              <li><span>начать обучение можно в любое удобное время;</span></li>
              <li><span>квалифицированные, опытные педагоги, в том числе и носители языка, которые заменят репетитора;</span></li>
              <li><span>увлекательная программа обучения, где в игровой форме изучается лексика и грамматика;</span></li>
              <li><span>доступная цена.</span></li>
            </ul>

            <p>Онлайн-школа для дошкольников по французскому языку помогает детям развить речевые навыки, творческое мышление, память и внимательность к деталям. Уроки помогают запомнить слова на повседневные темы, таким образом ребенок не растеряется и сможет поддержать разговор.</p>

            <p>Уроки составлены так, чтобы малыш не успел заскучать. На занятиях педагог рассказывает стишки, предлагает поиграть, петь песенки, порисовать, сделать поделки и все это на иностранном языке. Частая смена видов деятельности позволяет сохранить интерес к уроку и концентрацию внимания на протяжении всего занятия.</p>

            <p>Онлайн уроки французского для детей 4, 5 и 6 лет готовят ребенка к процессу обучения, слушать учителя, быть внимательным и выполнять задания. На онлайн-консультациях преподаватель ответит на возникшие вопросы как у ребенка, так и у взрослых. Такая возможность позволяет проверить правильность понимания грамматических правил, произношения.</p>

            <p>После прохождения курса ребенок получит яркий и красочный сертификат. Зарегистрируйтесь и приступайте к занятиям в удобное для вас время. Для достижения высоких результатов в обучении не критикуйте своего малыша, если что-то не получается с первого раза. Все начинают с нуля. Верьте в него, и все получится!</p>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Lang4Age1"
}
</script>

<style scoped>
.no-shadow p,li{color: #000; font-size: 18px;}
.no-shadow ul li{margin-bottom: 20px; padding-left: 10px;}
.no-shadow ul {list-style-image: url(~@/assets/hometeacher/images/redok.png);}
.no-shadow{margin-bottom: 70px;}
.no-shadow li{font-family: "Manrope Bold"; color:#5ab947;}
.no-shadow li span {font-family: "Manrope Light"; color: #000;}
.no-shadow ol li{margin-bottom: 20px; padding-left: 5px;}
</style>
